export default "__VITE_ASSET__nanEwiml__"